import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { BorderWrapper, Title, TableData } from 'components/styled-components';
import PrescreenDrawer from 'components/vendor-requests/prescreen-drawer';
import colors from 'utils/colors';
import map from 'lodash/map';
import filter from 'lodash/filter';
import join from 'lodash/join';
import { download } from 'utils/functions';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';
import { fetchSingleFile } from 'api/utils';
import { Popover, Button, Intent } from '@blueprintjs/core';
import { PaddingWrapper } from '../styled-components';
import { fetchPrescreenInstance } from 'actions/prescreen';

const Row = ({ data }) => (
  <TableRow>
    <TableData>{data.question}</TableData>
    <TableData>
      {join(filter(data.answers, a => a.selected).map(a => a.answer), ', ')}
    </TableData>
  </TableRow>
);

const PrescreenInfoBase = ({
  instance,
  vendorRequestID,
  request,
  fetchPrescreenInstance,
  files,
  appUser,
  prescreenAccepted,
}) => {
  useEffect(() => {
    fetchPrescreenInstance(vendorRequestID);
  }, []);
  return (
    <BorderWrapper margin="1rem">
      <PaddingWrapper>
        <Heading>
          <Title>Pre-Screen Information</Title>
          <Right>
            {hasPermission(appUser.permissions, [
              permissions.VIEW_QUESTIONNAIRE_ATTACHMENT,
              permissions.VIEW_OWNED_QUESTIONNAIRE_ATTACHMENT,
              permissions.VIEW_ALL_QUESTIONNAIRE_ATTACHMENT,
            ]) && (
              <Popover
                content={
                  <div style={{ padding: '1rem', overflowY: 'auto', maxHeight: '500px' }}>
                    <p>Click on a file to download it.</p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexWrap: 'wrap',
                      }}
                    >
                      {map(files, file => (
                        <Button
                          minimal
                          text={file.displayName}
                          onClick={() =>
                            fetchSingleFile(file.uploadID, 'PRESCREEN').then(
                              res => {
                                download(res, file.displayName);
                              }
                            )
                          }
                        />
                      ))}
                    </div>
                  </div>
                }
              >
                <Button
                  minimal
                  large
                  intent={Intent.PRIMARY}
                  text={`(${files.length}) Attachment(s)`}
                />
              </Popover>
            )}
            {request.statusCategory === 'Pending' &&
              prescreenAccepted === null &&
              hasPermission(
                appUser.permissions,
                permissions.MODIFY_ALL_IN_FLIGHT_THIRD_PARTY_REQUESTS
              ) && (
                <PrescreenDrawer
                  instance={instance}
                  vendorRequestID={vendorRequestID}
                  fetchPrescreenInstance={fetchPrescreenInstance}
                />
              )}
          </Right>
        </Heading>
      </PaddingWrapper>
      <Table>
        <thead>
          <TableRow>
            <TableHead>Question</TableHead>
            <TableHead>Answers</TableHead>
          </TableRow>
        </thead>
        <tbody>
          {map(instance, (pi, i) => (
            <Row key={i} data={pi} />
          ))}
        </tbody>
      </Table>
    </BorderWrapper>
  );
};

const Heading = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
const Right = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 3px;
`;

const TableRow = styled.tr`
  background: ${props => props.background || '#fff'};

  td {
    border-bottom: 1px solid ${colors.lightestGray};
  }
  &:first-child th {
    border-bottom: 1px solid ${colors.lightestGray};
  }
  &:last-child {
    border-bottom: none;
  }
`;

const TableHead = styled.th`
  text-align: left;
  color: ${colors.lightGray};
  margin-bottom: 0.5rem;
  font-weight: 400;
  padding: 1rem;
  border-bottom: 1px solid ${colors.lightGray};
`;

const mapStateToProps = state => ({
  files: state.utils.prescreenFiles,
  instance: state.prescreen.instance,
  appUser: state.auth.appUser,
});

const PrescreenInfo = connect(
  mapStateToProps,
  { fetchPrescreenInstance }
)(PrescreenInfoBase);
export default PrescreenInfo;
